<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-pencil"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Card do Formulario -->
<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon">
      <i class="pi pi-pencil"></i>
    </div>
    <span class="card-header-title">{{ texts.editar_cotacao }}</span>
  </div>
  <div class="card-content">
    <!-- Moeda Padrao -->
    <div class="form-row">
      <div class="form-item">
        <label class="form-label">{{ texts.moeda_padrao }}</label>
        <input
          pInputText
          [value]="moedaPadraoLabel"
          [disabled]="true"
          class="w-full" />
      </div>
    </div>

    <!-- Campos de Cotacao (filtrados conforme a moeda padrao da empresa) -->
    <div class="form-row">
      <div class="form-item" *ngIf="isVisivel('dolarGuarani')">
        <label class="form-label">
          <div class="currency-pair">
            <img src="assets/images/usa-flag.svg" class="flag-icon" alt="USA" />
            <span class="currency-separator">→</span>
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
            <span class="currency-name">{{ texts.dolar_guarani }}</span>
          </div>
        </label>
        <input
          [(ngModel)]="form.dolarGuarani"
          type="number"
          pInputText
          [placeholder]="placeholders.digite_o_valor"
          class="w-full" />
      </div>
      <div class="form-item" *ngIf="isVisivel('realGuarani')">
        <label class="form-label">
          <div class="currency-pair">
            <img src="assets/images/br-flag.svg" class="flag-icon" alt="BR" />
            <span class="currency-separator">→</span>
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
            <span class="currency-name">{{ texts.real_guarani }}</span>
          </div>
        </label>
        <input
          [(ngModel)]="form.realGuarani"
          type="number"
          pInputText
          [placeholder]="placeholders.digite_o_valor"
          class="w-full" />
      </div>
      <div class="form-item" *ngIf="isVisivel('dolarReal')">
        <label class="form-label">
          <div class="currency-pair">
            <img src="assets/images/usa-flag.svg" class="flag-icon" alt="USA" />
            <span class="currency-separator">→</span>
            <img src="assets/images/br-flag.svg" class="flag-icon" alt="BR" />
            <span class="currency-name">{{ texts.dolar_real }}</span>
          </div>
        </label>
        <input
          [(ngModel)]="form.dolarReal"
          type="number"
          pInputText
          [placeholder]="placeholders.digite_o_valor"
          class="w-full" />
      </div>
      <div class="form-item" *ngIf="isVisivel('pesoGuarani')">
        <label class="form-label">
          <div class="currency-pair">
            <img src="assets/images/argentina-flag.svg" class="flag-icon" alt="Argentina" />
            <span class="currency-separator">→</span>
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon" alt="Paraguay" />
            <span class="currency-name">{{ texts.peso_guarani }}</span>
          </div>
        </label>
        <input
          [(ngModel)]="form.pesoGuarani"
          type="number"
          step="0.01"
          min="0"
          pInputText
          [placeholder]="placeholders.peso_guarani"
          [attr.aria-label]="texts.peso_guarani"
          class="w-full" />
      </div>
    </div>

    <!-- Botoes -->
    <div class="form-actions">
      <button
        pButton
        [label]="botoes.cancelar"
        icon="pi pi-times"
        class="p-button-secondary"
        (click)="voltar()">
      </button>
      <button
        pButton
        [label]="botoes.salvar"
        icon="pi pi-check"
        (click)="submit()">
      </button>
    </div>
  </div>
</div>

<p-toast></p-toast>
